import React from 'react'
import PropTypes from 'prop-types'
import { View } from 'components/View'
import ContentBox from 'components/ContentBox'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextBodySmaller from 'components/TextBodySmaller'
import ButtonPrimary from 'components/ButtonPrimary'
import { Image } from 'components/Image'
import { useTheme } from 'modules/styles'

export default function ToolCard ({
  title,
  description,
  imageSource,
  ctaText,
  onClick
}) {
  const theme = useTheme()

  return (
    <ContentBox
      f
      onClick={onClick}
      style={{
        cursor: 'pointer',
        border: `1px solid ${theme.colors.border}`,
        borderRadius: theme.borderRadius.medium,
        backgroundColor: theme.colors.backgroundContent,
        transition: 'transform 0.2s, box-shadow 0.2s'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)'
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)'
        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)'
      }}
    >
      {/* Title */}
      <View mb>
        <TextTitleCompressedHeavy>
          {title}
        </TextTitleCompressedHeavy>
      </View>

      {/* Description */}
      <View mb={2}>
        <TextBodySmaller
          style={{ color: theme.colors.paragraph }}
        >
          {description}
        </TextBodySmaller>
      </View>

      {/* Image */}
      {imageSource && (
        <View mb={2}>
          <Image
            src={imageSource}
            alt={title}
            shouldLazyLoad
            style={{
              borderRadius: theme.borderRadius.medium,
              margin: '0 auto'
            }}
          />
        </View>
      )}

      {/* CTA Button */}
      <ButtonPrimary
        onClick={onClick}
        style={{ width: '100%' }}
      >
        {ctaText}
      </ButtonPrimary>
    </ContentBox>
  )
}

ToolCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imageSource: PropTypes.string,
  ctaText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}
